import Divider from './Divider';

export * from './DividerProps';
export default Divider;
